












import { Vue, Prop, Watch, Component } from "vue-property-decorator";
@Component( {
    name: "Componente",
    props: {},
    components: {}
} )
export default class Componente extends Vue {

    @Prop( { type: String } )
    public Titulo: string;

    @Prop( { type: String } )
    public Valor: string;

    @Prop( { type: String } )
    public Icono: string;

    @Prop( { type: Boolean } )
    public br: boolean;

    @Prop( { type: Boolean } )
    public nomargin: boolean;

    @Prop( { type: Boolean } )
    public small: boolean;

    @Prop( { type: Boolean, default: true } )
    public normal: boolean;

    @Prop( { type: Boolean } )
    public large: boolean;

    get FontSize(): number {
        if ( this.small ) return 14;
        else if ( this.large ) return 18;
        return 16;
    }

}
